module.exports = __webpack_public_path__ + "static/img/expression_wrinkles_stay-01.ededd74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/expression_wrinkles_stay-01.jpg
// module id = 267
// module chunks = 1